import { DEFAULT_LOCALE, getMessages, type ValidationMessages } from "@/i18n";

import type { ValidationResult } from "../types";

export function validatePasswordRepeat(
  value: string,
  password: string,
  validationMessages: ValidationMessages = getMessages(DEFAULT_LOCALE)
    .validation,
): ValidationResult {
  if (!value) {
    return validationMessages.passwordRepeatRequired;
  }

  if (value !== password) {
    return validationMessages.passwordMismatch;
  }

  return true;
}
